export const env = {
  ENV: 'PRODUCTION',
  API_BASE_URL: 'https://api.zetapp.in/',
} as const
